import { apiRoutes } from 'app/globals';
import BaseRepository from './BaseRepository';


export default class I18nRepository {

    static getTranslations(locale = 'en') {

        return fetch(`${apiRoutes.GET_TRANSLATIONS}/${locale}.json`, {
            method: 'get'
        })
            .then(BaseRepository.parseJSON)
            .catch(function (err) {
                console.error(err.toString());
            });
    }

}